import {createElement, createRoot} from '@wordpress/element';
import './style.scss';
import 'regenerator-runtime/runtime';
import {installApiFetchBridge} from "./bootstrap/installApiFetchBridge";
import {CatalogWrapper} from "./components/catalog/CatalogWrapper";
import {LandingPageWrapper} from "./components/landing/LandingPageWrapper";
import {ProductGallery} from "./components/details/ProductGallery";
import {ProductDetailsBody} from "./components/details/ProductDetailsBody";
import {ProductDetailsFooter} from "./components/details/ProductDetailsFooter";
import {ProductRecommendations} from "./components/details/ProductRecommendations";
import {HeaderSearchPopup} from "./components/common/HeaderSearchPopup";
import {AppShell} from "./components/common/AppShell";


const hidePageLoader = () => {
    const loader = document.getElementById('epi-page-loader');
    if (!loader) return;
    document.body.classList.remove('epi-loading');
    loader.classList.add('epi-loader-hidden');
};
installApiFetchBridge({stripApiPrefix: false, keepWpNonceOnExternal: false});
document.addEventListener('DOMContentLoaded', () => {

    const shellNode = document.createElement('div');
    shellNode.id = 'pt-app-shell';
    document.body.appendChild(shellNode);
    createRoot(shellNode).render(createElement(AppShell));

    const headerSearchInput = document.getElementById('pt-header-search-input');
    if (headerSearchInput) {
        const popupContainer = document.createElement('div');
        popupContainer.id = 'epi-header-search-popup-container';
        document.body.appendChild(popupContainer);
        createRoot(popupContainer).render(createElement(HeaderSearchPopup, {inputElement: headerSearchInput}));
    }

    hidePageLoader();

    document
        .querySelectorAll('.epi-product-search')
        .forEach(node => createRoot(node).render(createElement(CatalogWrapper, {container: node})));

    document
        .querySelectorAll('.product-gallery-react')
        .forEach(node => createRoot(node).render(createElement(ProductGallery, {container: node})));

    document
        .querySelectorAll('.product-details-body')
        .forEach(node => createRoot(node).render(createElement(ProductDetailsBody, {container: node})));

    document
        .querySelectorAll('.product-details-footer')
        .forEach(node => createRoot(node).render(createElement(ProductDetailsFooter, {container: node})));

    document
        .querySelectorAll('.product-recommendations')
        .forEach(node => createRoot(node).render(createElement(ProductRecommendations, {container: node})));

    document
        .querySelectorAll('.epi-landing-page')
        .forEach(node => {
            createRoot(node).render(createElement(LandingPageWrapper, {loading: true}));
        });
});